import { render, staticRenderFns } from "./RespondentFeedbackDialog.vue?vue&type=template&id=52220b70&scoped=true"
import script from "./RespondentFeedbackDialog.vue?vue&type=script&lang=js"
export * from "./RespondentFeedbackDialog.vue?vue&type=script&lang=js"
import style0 from "./RespondentFeedbackDialog.vue?vue&type=style&index=0&id=52220b70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52220b70",
  null
  
)

export default component.exports